import { useState } from "react";
import { TbWorldWww } from "react-icons/tb";
import { FaCode } from "react-icons/fa6";
const projects = {
  All: [
    {
      title: "Dreamy House",
      description: "A Home Decorator website built with Next.js and Tailwind CSS.",
      techStack: ["Next.js", "Tailwind CSS", "Framer Motion", "Material-Tailwind", "Next Aut"],
      preview: "https://dreamyhousetrading.com/"
    },
    {
      title: "Home Tutor",
      description: "A Home tutor service website built with Next.js and Tailwind CSS.",
      techStack: ["Next.js", "Tailwind CSS", "Framer Motion", "Material-Tailwind", "Next Aut", "Express.js", "Node.js", "Mongodb"],
      preview: "https://hometutorctg.netlify.app/"
    },

    {
      title: "Dainik Bayanno ",
      description: "A online news portal website built with Php and laravel,.",
      techStack: ["Html", "Tailwind CSS", "Framer Motion", "Php", "Laravel", "MySql", "Flowbite"],
      preview: "https://dainikbayanno.online/"
    },
    {
      title: "Doctors  ",
      description: "A  Treatment Service with appointment built with React.js, Express.js and Tailwind CSS,.",
      techStack: ["React.js", "Tailwind CSS", "Framer Motion", "Express.js", "Node.js", "JWT", "Firebase", "Mamba UI"],
      preview: "https://drbelalvai.web.app/home"
    },
    {
      title: "LEGAL AID  ",
      description: "A   Legal aid service built with React.js, Express.js and Tailwind CSS,.",
      techStack: ["React.js", "Tailwind CSS", "Framer Motion", "Express.js", "Node.js", "JWT", "Firebase", "Mamba UI"],
      preview: "https://legalaid-13b6d.web.app/home"
    },
    {
      title: "YD BIKE ",
      description: "A Resell Used Products built with React.js, Express.js and Tailwind CSS,.",
      techStack: ["React.js", "Tailwind CSS", "Framer Motion", "Express.js", "Node.js", "JWT", "Firebase", "Mamba UI"],
      preview: "https://ydbike-9f725.web.app/home"
    },
    {
      title: " Hafejia Travel Tours  ",
      description: "A Travel Agency website built with Next.js, Express.js and Tailwind CSS,.",
      techStack: ["React.js", "Tailwind CSS", "Framer Motion", "Express.js", "Node.js", "JWT", "Firebase", "Mamba UI"],
      preview: "https://ydbike-9f725.web.app/home"
    },
    {
      title: "Glams with beauty",
      description: "A E-commerce website built with Html, Bootstrap and Javascript",
      techStack: ["Html", " CSS", "Framer Motion", 'Bootstrap', "Javascript"],
      preview:"https://glamswithbeauty.netlify.app"
    },
    {
      title: "Dropt",
      description: "A modern games application React and Typescript",
      techStack: ["React", "Styled Components", "Material-Tailwind", "Typescript"],
      preview:"https://dropt.netlify.app/"
    },
    {
      title: "Consultancy Unified",
      description: "A modern Admission and circular provide with built Nextjs and Typescript",
      techStack: ["React", "Styled Components", "Material-Tailwind", "Typescript"],
      preview:"https://dropt.netlify.app/"
    },
    {
      title: "E-Commerce NaturabBd",
      description: "A E-commerce natural products website built with Html, Bootstrap and Javascript",
      techStack: ["Html", " CSS", "Framer Motion", 'Bootstrap', "Javascript"],
      preview:"https://naturalbdmoino.netlify.app/"
    },
    {
      title: "Our Course",
      description: "A landing page  built with Html, Bootstrap and Javascript",
      techStack: ["Html", " CSS", "Framer Motion", 'Bootstrap', "Javascript"],
      preview:"https://our-course.netlify.app/"
    },
  ],
  frontend: [
    {
      title: "Glams with beauty",
      description: "A E-commerce website built with Html, Bootstrap and Javascript",
      techStack: ["Html", " CSS", "Framer Motion", 'Bootstrap', "Javascript"],
      preview:"https://glamswithbeauty.netlify.app"
    },
    {
      title: "Dropt",
      description: "A modern games application React and Typescript",
      techStack: ["React", "Styled Components", "Material-Tailwind", "Typescript"],
      preview:"https://dropt.netlify.app/"
    },
    {
      title: "Consultancy Unified",
      description: "A modern Admission and circular provide with built Nextjs and Typescript",
      techStack: ["React", "Styled Components", "Material-Tailwind", "Typescript"],
      preview:"https://dropt.netlify.app/"
    },
    {
      title: "E-Commerce NaturabBd",
      description: "A E-commerce natural products website built with Html, Bootstrap and Javascript",
      techStack: ["Html", " CSS", "Framer Motion", 'Bootstrap', "Javascript"],
      preview:"https://naturalbdmoino.netlify.app/"
    },
    {
      title: "Our Course",
      description: "A landing page  built with Html, Bootstrap and Javascript",
      techStack: ["Html", " CSS", "Framer Motion", 'Bootstrap', "Javascript"],
      preview:"https://our-course.netlify.app/"
    },
  ],
  fullstack: [
    {
      title: "Dreamy House",
      description: "A Home Decorator website built with Next.js and Tailwind CSS.",
      techStack: ["Next.js", "Tailwind CSS", "Framer Motion", "Material-Tailwind", "Next Aut"],
      preview: "https://dreamyhousetrading.com/"
    },
    {
      title: "Home Tutor",
      description: "A Home tutor service website built with Next.js and Tailwind CSS.",
      techStack: ["Next.js", "Tailwind CSS", "Framer Motion", "Material-Tailwind", "Next Aut", "Express.js", "Node.js", "Mongodb"],
      preview: "https://hometutorctg.netlify.app/"
    },

    {
      title: "Dainik Bayanno ",
      description: "A online news portal website built with Php and laravel,.",
      techStack: ["Html", "Tailwind CSS", "Framer Motion", "Php", "Laravel", "MySql", "Flowbite"],
      preview: "https://dainikbayanno.online/"
    },
    {
      title: "Doctors  ",
      description: "A  Treatment Service with appointment built with React.js, Express.js and Tailwind CSS,.",
      techStack: ["React.js", "Tailwind CSS", "Framer Motion", "Express.js", "Node.js", "JWT", "Firebase", "Mamba UI"],
      preview: "https://drbelalvai.web.app/home"
    },
    {
      title: "LEGAL AID  ",
      description: "A   Legal aid service built with React.js, Express.js and Tailwind CSS,.",
      techStack: ["React.js", "Tailwind CSS", "Framer Motion", "Express.js", "Node.js", "JWT", "Firebase", "Mamba UI"],
      preview: "https://legalaid-13b6d.web.app/home"
    },
    {
      title: "YD BIKE ",
      description: "A Resell Used Products built with React.js, Express.js and Tailwind CSS,.",
      techStack: ["React.js", "Tailwind CSS", "Framer Motion", "Express.js", "Node.js", "JWT", "Firebase", "Mamba UI"],
      preview: "https://ydbike-9f725.web.app/home"
    },
    {
      title: " Hafejia Travel Tours  ",
      description: "A Travel Agency website built with Next.js, Express.js and Tailwind CSS,.",
      techStack: ["React.js", "Tailwind CSS", "Framer Motion", "Express.js", "Node.js", "JWT", "Firebase", "Mamba UI"],
      preview: "https://ydbike-9f725.web.app/home"
    },
  ],
  AppDevelopment: [
    {
      title: "API Service",
      description: "A Node.js REST API for user authentication and data management.",
      techStack: ["Node.js", "Express.js", "JWT", "MongoDB"],
    },
    {
      title: "Automation Script",
      description: "A Python script to automate repetitive tasks.",
      techStack: ["Python", "Selenium", "Pandas"],
    },
  ],
};

export default function Projects() {
  const [activeTab, setActiveTab] = useState("All");

  return (
    <div className="py-10 md:py-24 bg-gray-800 px-[8%]">
      {/* Heading */}
      <div className="mb-6">
        <h1 className="text-[#00A9FF] font-bold text-3xl">Recent Projects</h1>
      </div>

      {/* Tabs */}
      <div className="relative mx-auto w-auto max-w-full  rounded-xl shadow shadow-[#00A9FF]">
        <div className="flex space-x-4 px-6 sm:justify-center border-[#00A9FF] border mx-auto py-2 rounded-xl bg-gray-700 border-b pb-2 overflow-x-auto whitespace-nowrap scrollbar-hidden" style={{ WebkitOverflowScrolling: "touch" }}>
          {Object.keys(projects).map((category) => (
            <button
              key={category}
              onClick={() => setActiveTab(category)}
              className={`px-3 py-1 text-base font-bold text-white rounded-md transition ${activeTab === category ? "bg-[#00A9FF] text-white" : "bg-gray-700"
                }`}
            >
              {category.replace(/([A-Z])/g, " $1").trim()} {/* Converts 'AppDevelopment' to 'App Development' */}
            </button>
          ))}
        </div>
      </div>

      {/* Project Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        {projects[activeTab].map((project, index) => (
          <div key={index} className="border border-[#00A9FF] shadow-2xl bg-gray-900 rounded-xl p-4">
            <h3 className="text-lg text-[#00A9FF] font-medium">{project.title}</h3>
            <p className="text-gray-500 text-sm my-3">{project.description}</p>

            {/* Tech Stack */}
            <div className="flex flex-wrap gap-2 mt-2 my-4">
              {project.techStack.map((tech, i) => (
                <span key={i} className="bg-gray-900 shadow text-white shadow-white text-xs px-2 py-1 rounded-md">
                  {tech}
                </span>
              ))}
            </div>

            {/* Preview Button */}
            <div className="flex justify-end gap-3">
              <a href={project.preview} target="_blank" rel="noopener noreferrer">
                <button className="py-2 px-4 border border-[#00A9FF] text-[#00A9FF] hover:text-gray-800 font-semibold rounded-md flex items-center gap-2 hover:bg-white transition-all duration-200">
                  <TbWorldWww className="text-xl" />
                  Preview
                </button>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}